import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { IconChevronRight, IconPlus } from '../../components/Icons'
import ThemedSection from './ThemedSection'
import { Minus } from 'heroicons-react'
import SectionHeading from './SectionHeading'

export const AccordionSection = ({ section, isDark = false, theme = 'Light', className='w-11/12 max-w-[800px] mx-auto py-10  mx-auto relative justify-start items-start' }) => {
  const { heading, Accordion, image } = section
  const [activeQuestion, setActiveQuestion] = React.useState(false)

  const Heading = heading ? 'h3' : 'h2'

  return (
    <section
      className={
        (image ? 'grid grid-cols-1 xl:grid-cols-2 gap-2' : '') +
          className
      }
    >
      <div className={'leading-loose px-5 ' + (isDark ? ' prose-invert' : '')}>
        <div className="prose lg:prose-xl mb-6 mx-auto max-w-none">
          <SectionHeading>{heading}</SectionHeading>
        </div>
        {Accordion.map(item => (
          <div key={item.heading} className="fade-in-now">
            <Heading
              className={
                (activeQuestion === item.heading ? ' text-red-700  ' : '') +
                (theme === 'Light' ? ' bg-gray-100 ' : ' bg-white ') +
                ' cursor-pointer p-5 justify-between items-center flex text-lg font-bold mb-2 '
              }
              onClick={() => setActiveQuestion(id => (id === item.heading ? false : item.heading))}
            >
              {item.heading}
              <div className="relative size-5 flex justify-center items-center">
                <Minus
                  className={
                    (activeQuestion === item.heading
                      ? ' rotate-0 opacity-100 '
                      : ' rotate-90 opacity-0 ') + ' w-6 text-gray-400 duration-300 ease-in-out'
                  }
                />

                <IconPlus
                  className={
                    (activeQuestion === item.heading
                      ? ' rotate-45 opacity-0 '
                      : ' rotate-0 opacity-100') +
                    ' size-5 text-gray-400 absolute top-0 left-0 duration-300 ease-in-out '
                  }
                />
              </div>
            </Heading>
            <div
              className={
                (activeQuestion === item.heading
                  ? ' h-auto opacity-100 py-5 duration-200 '
                  : ' h-0 *:hidden duration-200 ') +
                ' prose lg:prose-xl px-5 decoration-red-600 decoration-2 underline-offset-4 ease-in-out max-w-none ' +
                (isDark ? ' prose-invert' : '')
              }
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        ))}
      </div>
    </section>
  )
}

AccordionSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    image: PropTypes.object,
    theme: PropTypes.string,
    layout: PropTypes.string,
    Accordion: PropTypes.arrayOf(
      PropTypes.shape({
        heading: PropTypes.string,
        content: PropTypes.string,
      })
    ),
  }),
  className: PropTypes.string,
}

AccordionSection.defaultProps = {
  section: {
    heading: '',
    image: [],
    theme: '',
    Accordion: [{}],
  },
  className: 'py-6 leading-loose',
}

export const query = graphql`
  fragment AccordionSection on STRAPI__COMPONENT_SECTION_ACCORDION_SECTION {
    id
    strapi_component
    heading
    Accordion {
      heading
      content
    }
  }
`

export default AccordionSection
